import React, { Component } from 'react';

import {
  Card,
  CardHeader,
  CardBody,
  Button,
  Collapse,
  Table
} from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCar,
  faChevronCircleDown,
  faChevronCircleLeft,
  faSpinner
} from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';

import Datatable from './components/Datatable.js';
import DemoAutoTable from './components/DemoAutoTable';

class AutoCard extends Component {
  constructor(props) {
    super(props); 
    this.state = {
      collapse: this.props.category === "Auto" ? true : false,
      buttonText: "Expand",
      isHovered: null
    };
  }

  toggle() {
    if(this.state.collapse) {
      this.setState({
        collapse: false,
        buttonText: "Expand"
      }); 
    } else {
      this.setState({
        collapse: true,
        buttonText: "Shrink"
      });  
    }
  }

  handleMouseEnter() {
    this.setState({ isHovered: true }); 
  }

  handleMouseLeave() {
    this.setState({ isHovered: false }); 
  }

  hasColumns(columns) {
    let data = this.props.currentDistrictsData;
    let hasColumns = false;  

    columns.forEach((item) => {
      if(data[item.column]) {
        hasColumns = true; 
      }
    });

    return hasColumns;
  }

  render() {
    const { currentDistrictsData, dataPointNames } = this.props;
    const tableColumns = dataPointNames.filter(dataPointName => dataPointName.category === "Auto")
      .map((dataPointName) => {
        return {title: dataPointName.title ? dataPointName.title : dataPointName.name, column: dataPointName.name}
      });
return (
      <Card className="mb-2">
        <CardHeader 
          className={(this.state.isHovered ? "bg-secondary" : "bg-primary") + " text-white d-flex flex-row"}
          onMouseEnter={this.handleMouseEnter.bind(this)}
          onMouseLeave={this.handleMouseLeave.bind(this)}
          onClick={this.toggle.bind(this)}
          style={ this.state.collapse ? {alignItems: "center"} : {alignItems: "center", borderRadius: "calc(0.25rem - 1px)"} }>
          <h4 className="mb-0">
            <span className="fa-layers fa-fw mr-4">
              <FontAwesomeIcon icon={faCircle} transform="grow-15" />
              <FontAwesomeIcon icon={faCar} />
            </span>
            Auto
          </h4>
          <h3 className="mb-0 ml-auto"><FontAwesomeIcon size="lg" icon={this.state.collapse ? faChevronCircleLeft : faChevronCircleDown} /></h3>
        </CardHeader>
        <Collapse isOpen={this.state.collapse}>
          <CardBody className={ this.props.loading ? "text-center" : null }>
            <Table bordered>
              <thead className="bg-secondary text-white">
                <tr>
                  <th></th>
                  <th>Male Drivers</th>
                  <th>Female Drivers</th>
                  <th>Total Cars on Road</th>
                  <th>Car Penetration per Capita</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2022</td>
                  <td>{currentDistrictsData && currentDistrictsData["Male Drivers"] ? currentDistrictsData["Male Drivers"]["2022"] : null}</td>
                  <td>{currentDistrictsData && currentDistrictsData["Female Drivers"] ? currentDistrictsData["Female Drivers"]["2022"] : null}</td>
                  <td>{currentDistrictsData && currentDistrictsData["Total Cars On Road"] ? currentDistrictsData["Total Cars On Road"]["2022"] : null}</td>
                  <td>{currentDistrictsData && currentDistrictsData["Car Penetration Per Capita"] ? currentDistrictsData["Car Penetration Per Capita"]["2022"] : null}</td>
                </tr>
              </tbody>
            </Table>
            <DemoAutoTable />
          </CardBody>
        </Collapse>
      </Card>
    ); 
  }
}

export default AutoCard;
